import { render } from "./TeacherAppointment.vue?vue&type=template&id=28bd26c4"
import script from "./TeacherAppointment.vue?vue&type=script&lang=js"
export * from "./TeacherAppointment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__